import { render } from "./ArticleDetail.vue?vue&type=template&id=78145939&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"

import "./ArticleDetail.vue?vue&type=style&index=0&id=78145939&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78145939"]])

export default __exports__